(function () {
  function init() {
    gsap.registerPlugin(ScrollTrigger)

    document.querySelectorAll('[data-tilt]').forEach(function (root) {
      if (root.dataset.tiltReady) return
      root.dataset.tiltReady = 'true'

      const items = root.querySelectorAll(root.getAttribute('data-tilt'))
      if (!items.length) return

      gsap.from(items, {
        rotate: 12,
        x: '0.5rem',
        y: '1rem',
        duration: 0.6,
        ease: 'power2.out',
        stagger: function (index) {
          return (index % 4) * 0.15
        },
        scrollTrigger: {
          trigger: root,
          start: 'top bottom',
          once: true
        }
      })
    })
  }

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    init()
  } else {
    window.addEventListener('load', init)
  }
})()
